// src/utils/CloudinaryImage.jsx
const CloudinaryImage = ({ 
    publicId, 
    width, 
    height, 
    crop = 'fill', 
    alt = '', 
    className = '', 
    style = {},
    fallbackUrl = null  // nếu muốn fallback cực hiếm
}) => {
    if (!publicId) {
        if (fallbackUrl) {
            return <img src={fallbackUrl} alt={alt} className={className} style={style} loading="lazy" />;
        }
        return null;
    }

    const transformations = [
        'f_auto',
        'q_auto',
        width ? `w_${width}` : '',
        height ? `h_${height}` : '',
        crop ? `c_${crop}` : ''
    ].filter(Boolean).join(',');

    const src = `https://res.cloudinary.com/dp9lxlric/image/upload/${transformations}/${publicId}`;

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={{ objectFit: 'cover', ...style }}
            loading="lazy"
        />
    );
};

export default CloudinaryImage;